import { Registry } from './registry';
export var SymbolRegistry = new Registry(function (s) {
  var _a;

  return (_a = s.description) !== null && _a !== void 0 ? _a : '';
});